<template>
  <div class="receipt-container">
    <div v-if="dailyOmset">
      <div
        v-for="(items, pageIndex) in hasil"
        :key="pageIndex"
        class="receipt-page"
      >
        <ReceiptHeader type="outlet" :data="outlet" />
        <div class="receipt-content">
          <div class="info-section">
            <div class="info-row">
              <div class="info-label">Tanggal:</div>
              <div class="info-value">
                {{ dateFormatter($route.query.start_date) }} s.d.
                {{ dateFormatter($route.query.end_date) }}
              </div>
            </div>
          </div>
          <div class="header-container">
            <h3 class="title"><b>LAPORAN PENJUALAN HARIAN</b></h3>
          </div>
          <div class="outgoing-detail" v-if="dailyOmset != null">
            <Toast />
            <div class="card print" id="printMe">
              <table class="detail-bon">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Tanggal / Jam</th>
                    <th>Invoice</th>
                    <th>Nama Kasir</th>
                    <th>Kode Label</th>
                    <th>Nama Barang</th>
                    <th>Kelompok Barang</th>
                    <th>Harga Jual (Rp)</th>
                    <th>Qty</th>
                    <th>Jumlah (Rp)</th>
                    <th>Diskon Item (Rp)</th>
                    <th>Diskon (Rp)</th>
                    <th>Infaq (Rp)</th>
                    <th>Pembulatan (Rp)</th>
                    <th>Voucher (Rp)</th>
                    <th>Omset (Rp)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, k) in items" :key="k">
                    <td v-if="row.isFirstOmsetRowOnPage" :rowspan="row.rowspan">
                      {{ row.transactionNo }}
                    </td>
                    <td v-if="row.isFirstOmsetRowOnPage" :rowspan="row.rowspan">
                      {{
                        moment(row.omset.trx_date).format(
                          'YYYY-MM-DD / HH:mm:ss'
                        )
                      }}
                    </td>
                    <td v-if="row.isFirstOmsetRowOnPage" :rowspan="row.rowspan">
                      {{ row.omset.invoice_number }}
                    </td>
                    <td v-if="row.isFirstOmsetRowOnPage" :rowspan="row.rowspan">
                      {{ row.omset.cashier }}
                    </td>
                    <td>{{ row.item.code }}</td>
                    <td>{{ row.item.name }}</td>
                    <td>{{ row.item.cat_code }}</td>
                    <td class="text-right">
                      {{ number_format(row.item.price, 0, ',', '.') }}
                    </td>
                    <td>{{ row.item.qty }}</td>
                    <td class="text-right">
                      {{
                        number_format(
                          row.item.qty * row.item.price,
                          0,
                          ',',
                          '.'
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{ number_format(row.item.discount_item, 0, ',', '.') }}
                    </td>
                    <td
                      v-if="row.isFirstOmsetRowOnPage"
                      :rowspan="row.rowspan"
                      class="text-right"
                    >
                      {{ number_format(row.omset.discount, 0, ',', '.') }}
                    </td>
                    <td
                      v-if="row.isFirstOmsetRowOnPage"
                      :rowspan="row.rowspan"
                      class="text-right"
                    >
                      {{ number_format(row.omset.infaq, 0, ',', '.') }}
                    </td>
                    <td
                      v-if="row.isFirstOmsetRowOnPage"
                      :rowspan="row.rowspan"
                      class="text-right"
                    >
                      {{ number_format(row.omset.round_up, 0, ',', '.') }}
                    </td>
                    <td
                      v-if="row.isFirstOmsetRowOnPage"
                      :rowspan="row.rowspan"
                      class="text-right"
                    >
                      {{ number_format(row.omset.voucher, 0, ',', '.') }}
                    </td>
                    <td
                      v-if="row.isFirstOmsetRowOnPage"
                      :rowspan="row.rowspan"
                      class="text-right"
                    >
                      {{ number_format(row.omset.omset, 0, ',', '.') }}
                    </td>
                  </tr>
                  <tr v-if="pageIndex + 1 === hasil.length" class="total-row">
                    <td colspan="8"><b>TOTAL</b></td>
                    <td>{{ summary.total_qty }}</td>
                    <td class="text-right">
                      {{
                        number_format(summary.total_item_amount, 0, ',', '.')
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        number_format(summary.total_discount_item, 0, ',', '.')
                      }}
                    </td>
                    <td class="text-right">
                      {{ number_format(summary.total_discount, 0, ',', '.') }}
                    </td>
                    <td class="text-right">
                      {{ number_format(summary.total_infaq, 0, ',', '.') }}
                    </td>
                    <td class="text-right">
                      {{ number_format(summary.total_round_up, 0, ',', '.') }}
                    </td>
                    <td class="text-right">
                      {{ number_format(summary.total_voucher, 0, ',', '.') }}
                    </td>
                    <td class="text-right">
                      {{ number_format(summary.total_omset, 0, ',', '.') }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReceiptHeader from '@/components/receipt/ReceiptHeader.vue'
var moment = require('moment')

export default {
  name: 'DailyOmsetReceipt',
  components: {
    ReceiptHeader
  },
  data() {
    return {
      today: new Date().toISOString().split('T')[0],
      moment: moment,
      expandedRows: [],
      confirmDialog: false,
      dailyOmset: null,
      hasil: [],
      outlet: null,
      summary: {
        total_qty: null,
        total_item_amount: null,
        total_discount_item: null,
        total_discount: null,
        total_infaq: null,
        total_round_up: null,
        total_voucher: null,
        total_omset: null
      }
    }
  },
  mounted() {
    this.getOutlet()
    this.getDailyOmset()
    // Add afterprint event listener to close window
    window.addEventListener('afterprint', this.handleAfterPrint)
  },
  beforeDestroy() {
    window.removeEventListener('afterprint', this.handleAfterPrint)
  },
  methods: {
    getOutlet() {
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/outlets/${this.$route.query.outlet_id}`
        )
        .then(response => {
          if (response.status === 200) {
            this.outlet = response.data.data.outlets
          }
        })
    },
    getDailyOmset() {
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/pos/dailyomset?start_date=${this.$route.query.start_date}&end_date=${this.$route.query.end_date}`
        )
        .then(response => {
          if (response.status === 200) {
            this.dailyOmset = response.data.data.daily_omset
            this.hasil = this.paginateWithRowspan(this.dailyOmset, 25)
            this.summary.total_qty = response.data.data.total_qty
            this.summary.total_item_amount =
              response.data.data.total_item_amount
            this.summary.total_discount_item =
              response.data.data.total_discount_item
            this.summary.total_discount = response.data.data.total_discount
            this.summary.total_infaq = response.data.data.total_infaq
            this.summary.total_round_up = response.data.data.total_round_up
            this.summary.total_voucher = response.data.data.total_voucher
            this.summary.total_omset = response.data.data.total_omset
            this.$nextTick(() => {
              setTimeout(() => {
                window.print()
              }, 500)
            })
          }
        })
    },
    paginateWithRowspan(dailyOmset, maxPerPage = 25) {
      // Step 1: Flatten and annotate
      const flatRows = []
      dailyOmset.forEach((omset, omsetIdx) => {
        omset.items.forEach((item, itemIdx) => {
          flatRows.push({
            omset,
            item,
            omsetIdx,
            itemIdxInOmset: itemIdx,
            omsetItemsCount: omset.items.length
          })
        })
      })
      // Step 2: Paginate
      const pages = []
      let transactionNo = 1
      let omsetNoMap = {}
      for (let i = 0; i < flatRows.length; i += maxPerPage) {
        const pageRows = flatRows.slice(i, i + maxPerPage)
        const omsetRowspans = {}
        pageRows.forEach((row, idx) => {
          const omsetKey = row.omsetIdx
          if (!omsetRowspans[omsetKey]) {
            omsetRowspans[omsetKey] = pageRows.filter(
              r => r.omsetIdx === omsetKey
            ).length
          }
          row.rowspan = omsetRowspans[omsetKey]
          row.isFirstOmsetRowOnPage = !pageRows
            .slice(0, idx)
            .some(r => r.omsetIdx === omsetKey)
          if (!(omsetKey in omsetNoMap)) {
            omsetNoMap[omsetKey] = transactionNo++
          }
          row.transactionNo = omsetNoMap[omsetKey]
        })
        pages.push(pageRows)
      }
      return pages
    },
    handleAfterPrint() {
      window.close()
    },
    number_format(number, decimals, dec_point, thousands_sep) {
      number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
      let n = !isFinite(+number) ? 0 : +number
      let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
      let sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep
      let dec = typeof dec_point === 'undefined' ? '.' : dec_point
      let s = ''

      let toFixedFix = function (n, prec) {
        let k = Math.pow(10, prec)
        return '' + Math.round(n * k) / k
      }

      s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
      if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
      }
      if ((s[1] || '').length < prec) {
        s[1] = s[1] || ''
        s[1] += new Array(prec - s[1].length + 1).join('0')
      }

      return s.join(dec)
    },
    dateFormatter(date) {
      return moment(date).format('DD MMMM YYYY')
    }
  }
}
</script>
<style scoped lang="scss">
table.detail-bon {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
  font-family: inherit; /* Use the same font as the header */
  font-size: 12px;
}
table.detail-bon th,
table.detail-bon td {
  border: 1px solid #000;
  padding: 8px 6px;
  text-align: center;
}
table.detail-bon th {
  background-color: #f0f0f0;
  font-weight: 600;
}
table.detail-bon tbody tr:nth-child(odd) {
  background-color: #fff;
}
table.detail-bon tbody tr:nth-child(even) {
  background-color: #f8f9fa;
}
.total-row {
  font-weight: 600;
  background-color: #f8f9fa;
}
.outgoing-detail {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  overflow: hidden;
}

.border-header {
  border-top: 2px solid black;
  width: 82%;
  margin-top: -4vh;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
}

.title-header {
  margin-left: -5rem;
  line-height: 0.5;
}

.image {
  margin: auto;
  margin-left: 90px;
}

.title {
  text-align: center;
}

.detail-bon {
  margin-left: auto;
  margin-right: auto;
}

th,
td {
  padding: 5px;
}
</style>
